import React, { ComponentType } from 'react';
import PaddingBox, { Side } from '@uds/padding-box';
import { Container } from '@uds/grid';
import errorBoundary from 'presentation/hocs/errorBoundary';
import visibilitySet from 'presentation/hocs/visibilitySet';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { InlinePrivacy } from '@uds/privacy-manager';
import { useTealiumCategories } from '@ux/whitelabel';

import Ribbon from '../Ribbon';

const PureInlinePrivacy = ({ id, name, layout, colorway, loading }: RibbonProps) => {
  const categories = useTealiumCategories() ?? [];
  return (
    <Ribbon id={id} name={name} layout={layout} colorway={colorway} loading={loading} type={Type.INLINE_PRIVACY}>
      <Container>
        <PaddingBox side={Side.X}>
          <InlinePrivacy order={categories} />
        </PaddingBox>
      </Container>
    </Ribbon>
  );
};

export default errorBoundary(visibilitySet(PureInlinePrivacy)) as ComponentType<RibbonProps>;
